export type RetryOptions = {
    retries?: number;
    interval?: number;
    backoffExponent?: number;
};

// Based on https://github.com/gregberge/loadable-components/issues/667
// const Example = loadable(() => retry(() => import('./Example'), { retries: 3 }));
export function retry<R>(
    fn: () => Promise<R>,
    { retries = 3, interval = 500, backoffExponent = 1 }: RetryOptions = {}
) {
    return new Promise<R>((resolve, reject) => {
        fn()
            .then(resolve)
            .catch((error) => {
                console.warn(`Chunk failed to load, retrying. Attempts left: ${retries}.`, error);
                setTimeout(() => {
                    if (retries === 1) {
                        reject(error);
                        return;
                    }

                    // Passing on "reject" is the important part
                    retry(fn, {
                        retries: retries - 1,
                        interval: interval * backoffExponent,
                    }).then(resolve, reject);
                }, interval);
            });
    });
}
